<template>
  <v-form ref="textForm" @submit.native.prevent="submit()">
    <div class="d-flex align-center">
      <v-text-field type="text" filled hide-details dense v-model="model.value" autocomplete="off"/>
      <v-btn type="primary" class="ml-2" @click="submit">{{buttonText || $t('button.save')}}</v-btn>
    </div>
  </v-form>
</template>
<script>
export default {
  mounted () {
    this.model.value = this.value
  },
  data () {
    return {
      message: null,
      isLoading: false,
      model: {
        value: null
      }
    }
  },
  watch: {
    'model.value': {
      handler: function (val) {
        this.$emit('input', val)
      }
    },
    value (val) {
      this.model.value = val
    }
  },
  props: {
    rules: {
      type: [Object, Array],
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    }
  },
  methods: {
    submit () {
      if (this.$refs.textForm.validate()) {
        this.$emit('change')
      }
    }
  }
}
</script>
